import { GlobalFooter } from "@/patterns/global-footer/src/index";
import StickyContainer from "@/patterns/sticky-container/sticky-container";

import {
    BlogsSection,
    JiraPlainBanners,
    CTASection,
    DevOpsSection,
    LoggedInHeroSection,
    IntegrationSection,
    ScalingSection,
    TabsSection,
    WorkflowSection
} from "..";
import { ParentScrollTracking } from "../../../../../../utils/scroll-tracking";
import JiraEnhancedAboveNavBanners from "../../../sections/nav-bar/above-nav-butterbar";
import JiraSoftwareNavV2 from "../../../sections/nav-bar/software-jira-navbar";

export const LoggedInJiraProductTourOverview = () => {
    return (
        <div>
            <StickyContainer>
                <JiraEnhancedAboveNavBanners />
                <JiraSoftwareNavV2 />
            </StickyContainer>
            <ParentScrollTracking scrollTrackingEnabled={true} pageId="jsw">
                <JiraPlainBanners />
                <LoggedInHeroSection />
                <TabsSection />
                <WorkflowSection />
                <IntegrationSection />
                <DevOpsSection />
                <BlogsSection />
                <ScalingSection />
                <CTASection />
                <GlobalFooter />
            </ParentScrollTracking>
        </div>
    );
};
